var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body",staticStyle:{"height":"100vh","width":"100vw"}},[_c('div',{staticClass:"text-center mt-5"},[_c('h1',[_vm._v("404 Not Found")]),_c('h4',[_vm._v("The page you are trying to access does not exist.")])]),_c('div',{staticClass:"text-center mt-5"},[_c('img',{attrs:{"src":require("@/assets/img/404/404.png")}})])])
}]

export { render, staticRenderFns }